import React, { useEffect, useState } from 'react';
import {
  characterLimit,
  EventPaperProps,
  cannedResponseSuccess,
} from 'constants';
import {
  onSave,
  refinePayload,
  useNotification,
  fieldValidation,
  getDialogHeading,
  renderSaveCancelButtons,
} from 'utils/commonUtils';
import * as yup from 'yup';
import Grid from '@mui/material/Grid';
import {
  putCannedResponse,
  postCannedResponse,
} from '../services/cannedResponsesApi';
import Dialog from '@mui/material/Dialog';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { GridForm } from 'components/Ui/styled';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormInputText } from 'components/Common/Forms/FormTextField';
import { FormInputSwitch } from 'components/Common/Forms/FormInputSwitch';

const cannedResponseFormValidationSchema = yup.object().shape({
  text: fieldValidation(characterLimit),
});

const CannedResponseDialog = (props) => {
  const {
    open,
    setOpen,
    cannedResponseForm,
    isNewCannedResponse,
    setCannedResponseForm,
    setIsNewCannedResponse,
    fetchCannedResponsesListData,
  } = props;

  const dispatch = useDispatch();
  const { NotificationPopup, setOpenNotification, setNotificationMessage } =
    useNotification();

  const { resourceId, text, pinned } = cannedResponseForm;

  const [loadingButton, setLoadingButton] = useState(false);

  const defaultValue = {
    text: text,
    pinned: pinned,
  };

  const useFunction = useForm({
    mode: 'onChange',
    defaultValues: defaultValue,
    resolver: yupResolver(cannedResponseFormValidationSchema),
  });

  const { handleSubmit, reset, control, formState } = useFunction;

  const { errors } = formState;

  useEffect(() => {
    if (open) {
      reset(defaultValue);
    }
  }, [open]);

  const handleClose = () => {
    setOpen(false);
    setCannedResponseForm({});
    setIsNewCannedResponse(false);
  };

  const onSubmit = (data) => {
    const { text, pinned = false } = data;

    const payload = {
      text,
      ...(isNewCannedResponse && { pinned: pinned }),
    };

    onSave(
      cannedResponseSuccess,
      isNewCannedResponse,
      postCannedResponse,
      putCannedResponse,
      refinePayload(payload),
      resourceId,
      fetchCannedResponsesListData,
      handleClose,
      setOpenNotification,
      setNotificationMessage,
      dispatch,
      setLoadingButton
    );
  };

  return (
    <>
      <Dialog open={open} PaperProps={EventPaperProps}>
        {getDialogHeading('Canned Response', handleClose)}
        <GridForm container spacing={2}>
          <Grid item xs={12}>
            <FormInputText
              type="text"
              name="text"
              label="Text"
              control={control}
              required={true}
              errors={!!errors.text}
              helperText={errors?.text?.message}
            />
          </Grid>
          {/* <Grid item xs={12}>
            <FormInputSwitch
              disabled={!isNewCannedResponse}
              control={control}
              name="pinned"
              label="Pinned"
              checked={defaultValue.pinned}
            />
          </Grid> */}
          {renderSaveCancelButtons(
            handleClose,
            handleSubmit(onSubmit),
            loadingButton
          )}
        </GridForm>
        <NotificationPopup />
      </Dialog>
    </>
  );
};

export default CannedResponseDialog;
